import { useRouter } from "next/router";
import { useCookies } from "react-cookie";
import Head from "next/head";

export default function LanguageSwitcher() {
  const [cookie, setCookie] = useCookies(["NEXT_LOCALE"]);
  const router = useRouter();
  const { locale } = router;
  const SITE_URL = "https://localhost:3000/";

  const switchLanguage = (e) => {
    const locale = e.target.value + router.pathname;
    router.push("/", "/", { locale });
    if (cookie.NEXT_LOCALE !== locale) {
      setCookie("NEXT_LOCALE", locale, { path: "/" });
    }
  };

  return (
    <div>
      <Head>
        <link rel="alternate" hrefLang={locale} href={`${SITE_URL}${locale}`} />
      </Head>

      <select onChange={switchLanguage} defaultValue={locale}>
        <option value="pl">PL</option>
        <option value="en">EN</option>
      </select>
    </div>
  );
}
